import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "fullpage ma-0 pa-0",
    style: `background-color: ${_vm.statusDetails.bgColor}`
  }), _c('div', {
    class: `fullpage ${_vm.mode} mx-0`,
    staticStyle: {
      "background-color": "rgba(0, 0, 0, 0.2)"
    }
  }, [_vm.treeMenu ? _c(VMenu, {
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 10,
      "position-x": _vm.treeMenuPosition.x,
      "position-y": _vm.treeMenuPosition.y,
      "transition": "scale-transition",
      "offset-y": "",
      "absolute": "",
      "min-width": "320px",
      "max-height": "500px"
    },
    model: {
      value: _vm.treeMenu,
      callback: function ($$v) {
        _vm.treeMenu = $$v;
      },
      expression: "treeMenu"
    }
  }, [_c(VCard, [_c('core-dtwin-tree-default', {
    ref: "twin-tree",
    attrs: {
      "selectionObjectFilter": _vm.digitalTwinFilter,
      "activeDtwinId": _vm.selectedDtwin.id,
      "searchEnabled": false
    },
    on: {
      "onSelectedChange": _vm.digitalTwinSelected
    }
  })], 1)], 1) : _vm._e(), _c('audio', {
    ref: "alarm-player",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "src": _vm.audioPath,
      "preload": "auto"
    }
  }), _c('audio', {
    ref: "dummy-audio",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "preload": "auto"
    }
  }, [_c('source', {
    attrs: {
      "src": "res/silent.ogg",
      "type": "audio/ogg"
    }
  }), _c('source', {
    attrs: {
      "src": "res/silent.mp3",
      "type": "audio/mpeg"
    }
  })]), _c(VRow, {
    staticClass: "my-0 py-0",
    staticStyle: {
      "height": "calc(100% - 108px)"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VBtn, {
    class: 'v-btn-x mx-1 mt-0 pt-0 v-btn--rounded bg-rounded-button-' + _vm.color,
    staticStyle: {
      "opacity": "0.15"
    },
    attrs: {
      "color": _vm.color,
      "title": _vm.$i18n_t('Common.back'),
      "icon": "",
      "info": "",
      "fab": "",
      "text": "",
      "to": _vm.homeLink
    }
  }, [_c(VIcon, {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fal fa-arrow-alt-left")])], 1), _c(VBtn, {
    class: 'v-btn-x mx-1 mt-0 pt-0 v-btn--rounded bg-rounded-button-' + _vm.color,
    attrs: {
      "color": _vm.color,
      "icon": "",
      "info": "",
      "fab": "",
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.showInitialInteractionButton = false;
        _vm.soundIsMuted = !_vm.soundIsMuted;
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fal fa-" + _vm._s(_vm.soundIsMuted ? 'volume-mute' : 'volume'))])], 1), _c(VBtn, {
    class: 'v-btn-x px-3 mt-0 bg-rounded-button-' + _vm.color,
    attrs: {
      "color": _vm.color,
      "rounded": "",
      "text": ""
    },
    on: {
      "click": _vm.doOpenTree
    }
  }, [_c(VIcon, {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fal fa-sensor-on")]), _vm._v("  \n          " + _vm._s(_vm.get(_vm.selectedDtwin, 'title')) + "\n          " + _vm._s(_vm.get(_vm.warnState, 'properties.title') ? '/' : '') + "\n          " + _vm._s(_vm.get(_vm.warnState, 'properties.title')) + "\n        ")], 1)], 1), _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VRow, {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_vm.showInitialInteractionButton || !_vm.statusDetails.icon && !_vm.statusDetails.img || !_vm.get(_vm.selectedDtwin, 'id') || !_vm.get(_vm.warnState, 'id') ? _c(VProgressCircular, {
    attrs: {
      "size": _vm.showInitialInteractionButton ? 30 : 90,
      "width": _vm.showInitialInteractionButton ? 2 : 4,
      "color": "white",
      "indeterminate": ""
    }
  }) : _vm.statusDetails.icon ? _c(VIcon, {
    staticStyle: {
      "font-size": "90px"
    },
    attrs: {
      "dark": ""
    }
  }, [_vm._v(_vm._s(_vm.statusDetails.icon))]) : _c('img', {
    staticClass: "grey lighten-2 image-preview elevation-3",
    staticStyle: {
      "object-fit": "contain",
      "width": "150px",
      "border-radius": "8px",
      "opacity": "0.85"
    },
    attrs: {
      "src": _vm.statusDetails.img
    }
  })], 1), _vm.showInitialInteractionButton ? _c(VRow, {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c(VIcon, {
    staticClass: "mt-6",
    staticStyle: {
      "font-size": "60px"
    },
    attrs: {
      "dark": ""
    },
    on: {
      "click": function ($event) {
        _vm.playDummyAudio();
        _vm.showInitialInteractionButton = false;
      }
    }
  }, [_vm._v("\n            fal fa-play\n          ")])], 1) : _c(VRow, {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_vm.get(_vm.selectedDtwin, 'id') && _vm.get(_vm.warnState, 'id') ? _c(VCol, {
    attrs: {
      "cols": "12",
      "align": "center"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.get(_vm.warnState, 'properties.title') || 'Status') + ": " + _vm._s(_vm.statusDetails.label))]), _c('h4', [_vm._v(_vm._s(_vm.formattedStateValue))])]) : _c(VCol, {
    attrs: {
      "cols": "12",
      "align": "center"
    }
  }, [_c('p', {
    staticClass: "text-bold"
  }, [_vm._v(_vm._s(_vm.$i18n_t('IS.Warnapp.selectTwinText')))])])], 1)], 1)], 1), _c(VRow, {
    staticClass: "pa-0 ma-0"
  }, [_c(VCol, {
    staticClass: "py-0 px-3 mb-2 mt-0",
    attrs: {
      "cols": "12",
      "align": "right"
    }
  }, [_vm.logoUrl ? _c('img', {
    staticClass: "elevation-3",
    staticStyle: {
      "height": "100px",
      "object-fit": "contain",
      "border-radius": "4px"
    },
    attrs: {
      "src": _vm.logoUrl
    }
  }) : _vm._e()])], 1)], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };